import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {ProjectDetails} from 'common/report/stores/project-details';
import {ProjectFeatureFlag} from 'common/report/constants';

export function canUseMultiAttribution(currentProject?: CurrentProject | ProjectDetails): boolean {
  return Boolean(currentProject?.hasFeatureFlag(ProjectFeatureFlag.MultiAttribution));
}
